import React from "react";
import {
  black,
  gray2,
  gray4,
  gray5,
  gray6,
  mainColor,
} from "assets/styleUtils";
import { ICompanyReview } from "data/company";
import moment from "moment";
import styles from "./style.module.css";

export default function ReviewItem({ review }: { review: ICompanyReview }) {
  const {
    content,
    user,
    updatedDt,
    photo,
    createdAt,
    contract_yn,
    blind_yn,
    blind_content,
    visit_day,
    confirm_yn,
  } = review;

  function dateFormat(date: string) {
    const today = moment(new Date()).format("YY.MM.DD");
    const writeDay = moment(new Date(createdAt)).format("YY.MM.DD");
    if (today === writeDay) return "오늘";
    return writeDay;
  }

  return (
    <div
      style={{
        width: "100%",
        paddingTop: "24px",
        paddingBottom: "19px",
        marginBottom: "24px",
        cursor: "pointer",
      }}
    >
      <div style={{ padding: "0 12px" }}>
        <div
          style={{
            width: "100%",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
            marginBottom: "10px",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <img
              src={
                user.profile_img ? user.profile_img : "/images/defaultImg.png"
              }
              style={{
                width: "32px",
                height: "32px",
                borderRadius: "16px",
                marginRight: "12px",
              }}
            />
            <div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <div className={styles.commonFontSize} style={{ color: gray2 }}>
                  {user.nickname}
                </div>
                {!!visit_day && (
                  <div
                    className={styles.commonFontSize}
                    style={{ marginLeft: "4px", color: gray4 }}
                  >
                    {`(${visit_day.substring(2, 4)}.${visit_day.substring(
                      5,
                      7
                    )}.${visit_day.substring(8, 10)} 방문)`}
                  </div>
                )}
                {(confirm_yn === "Y" || contract_yn === "Y") && (
                  <div
                    style={{
                      backgroundColor: "#E1ECED",
                      padding: "2px 4px",
                      borderRadius: "2px",
                      marginLeft: "4px",
                    }}
                  >
                    <div
                      style={{
                        fontSize: "10px",
                        lineHeight: "15px",
                        fontWeight: "500",
                        color: mainColor,
                      }}
                    >
                      계약인증
                    </div>
                  </div>
                )}
              </div>
              <div style={{ flexDirection: "row", alignItems: "center" }}>
                <div className={styles.commonFontSize} style={{ color: gray4 }}>
                  {dateFormat(user.createdAt)}
                  {!!updatedDt && ", 수정됨"}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div
          style={{
            marginBottom: "12px",
            fontSize: "14px",
            lineHeight: "21px",
            color: blind_yn === "N" ? black : gray5,
            whiteSpace: "pre-wrap",
          }}
        >
          {blind_yn === "N"
            ? content.slice(0, 40) + "..."
            : `정보통신망법에 의해 블라인드 처리 되었습니다.\n(${blind_content})`}
        </div>
        {blind_yn === "N" && photo && (
          <div
            className={styles.reviewImageScroll}
            style={{
              marginBottom: "12px",
              display: "flex",
              overflowX: photo.length > 2 ? "scroll" : "hidden",
            }}
          >
            {photo.map(({ no, img_url }, i) => (
              <div
                key={no}
                style={{
                  width: "100px",
                  height: "100px",
                  marginRight: "10px",
                }}
              >
                <img
                  src={img_url}
                  style={{
                    width: "100px",
                    height: "100px",
                    borderRadius: "4px",
                  }}
                />
              </div>
            ))}
          </div>
        )}
      </div>
      <div className={styles.borderBox} />
    </div>
  );
}
